"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
var grayScale = function (colorStart, colorEnd) {
    var gray = {
        10: '',
        20: '',
        30: '',
        40: '',
        50: '',
        60: '',
        70: '',
        80: '',
        90: '',
        100: '',
    };
    var scale = chroma_js_1.default.scale([colorStart, colorEnd]).colors(10);
    scale.forEach(function (tint, index) {
        var key = ((index + 1) * 10);
        gray[key] = tint;
    });
    return gray;
};
exports.default = grayScale;
